const STORAGE_KEY = 'ps_lang';

type Lang = 'en' | 'es';

export function getStoredLanguage(): Lang {
  try {
    let v = localStorage.getItem(STORAGE_KEY);
    if (!v) {
      // Backward compatibility: support existing i18next projects
      const legacy = localStorage.getItem('i18nextLng');
      if (legacy) {
        v = legacy;
        // Normalize and persist into our key so future reads don't depend on legacy key
        localStorage.setItem(STORAGE_KEY, legacy.startsWith('es') ? 'es' : 'en');
      }
    }
    if (!v) v = navigator.language || 'en';
    return v.startsWith('es') ? 'es' : 'en';
  } catch {
    return 'en';
  }
}

export function setStoredLanguage(lang: Lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
    // Keep legacy key in sync if it existed (harmless otherwise) so any old code paths still reflect change
    localStorage.setItem('i18nextLng', lang);
  } catch {
    // Ignore localStorage errors (e.g., in private browsing mode)
  }
}

let listeners: Array<(l: Lang)=>void> = [];
export function onLanguageChange(cb: (l: Lang)=>void) {
  listeners.push(cb);
  return () => { listeners = listeners.filter(x => x !== cb); };
}

export function changeLanguage(lang: Lang) {
  setStoredLanguage(lang);
  listeners.forEach(l => l(lang));
}
